var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    overflow: "visible",
    display: "inline-block",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.407 18.407L12.47 13.47l.657-.706a7 7 0 10-1.385 1.152l.671-.426 4.988 4.92.005-.004z",
    stroke: "#869096",
    strokeWidth: 2,
    fill: "none",
    fillRule: "evenodd"
  })));
}
export default SvgSearch;